export const SENTRY_RELEASE: string | undefined = '103e917508ffeb57802f7d9e390d4a36b709df91';
